import {Action} from "redux";

import {
    GetProjectByCustomerRequest,
    CreateEntryByCustomerRequest,
    DeleteEntryByCustomerRequest,
} from "../request/project_request";
import {
    GetProjectByCustomerResponse,
    GetEntryProjectsByCustomerResponse,
} from "../response/project_response";

export enum CustomerProjectActionType {
    REQUEST_GET_PROJECT = "CUSTOMER_PROJECT_REQUEST_GET_PROJECT",
    CALLBACK_GET_PROJECT = "CUSTOMER_PROJECT_CALLBACK_GET_PROJECT",
    REQUEST_GET_ENTRY_PROJECTS = "CUSTOMER_PROJECT_REQUEST_GET_ENTRY_PROJECTS ",
    CALLBACK_GET_ENTRY_PROJECTS  = "CUSTOMER_PROJECT_CALLBACK_GET_ENTRY_PROJECTS ",
    REQUEST_CREATE_ENTRY = "CUSTOMER_PROJECT_REQUEST_CREATE_ENTRY",
    CALLBACK_CREATE_ENTRY = "CUSTOMER_PROJECT_CALLBACK_CREATE_ENTRY",
    REQUEST_DELETE_ENTRY = "CUSTOMER_PROJECT_REQUEST_DELETE_ENTRY",
    CALLBACK_DELETE_ENTRY = "CUSTOMER_PROJECT_CALLBACK_DELETE_ENTRY",

}

export interface IRequestGetProjectAction extends Action {
    type: CustomerProjectActionType.REQUEST_GET_PROJECT;
    item: GetProjectByCustomerRequest,
}

export interface ICallbackGetProjectAction extends Action {
    type: CustomerProjectActionType.CALLBACK_GET_PROJECT;
    isSuccess: boolean;
    item?: GetProjectByCustomerResponse;
    error?: any;
}

export interface IRequestGetEntryProjectsAction extends Action {
    type: CustomerProjectActionType.REQUEST_GET_ENTRY_PROJECTS;
}

export interface ICallbackGetEntryProjectsAction extends Action {
    type: CustomerProjectActionType.CALLBACK_GET_ENTRY_PROJECTS;
    isSuccess: boolean;
    item?: GetEntryProjectsByCustomerResponse;
    error?: any;
}

export interface IRequestCreateEntryAction extends Action {
    type: CustomerProjectActionType.REQUEST_CREATE_ENTRY;
    item: CreateEntryByCustomerRequest,
}

export interface ICallbackCreateEntryAction extends Action {
    type: CustomerProjectActionType.CALLBACK_CREATE_ENTRY;
    isSuccess: boolean;
    error?: any;
}

export interface IRequestDeleteEntryAction extends Action {
    type: CustomerProjectActionType.REQUEST_DELETE_ENTRY;
    item: DeleteEntryByCustomerRequest,
}

export interface ICallbackDeleteEntryAction extends Action {
    type: CustomerProjectActionType.CALLBACK_DELETE_ENTRY;
    isSuccess: boolean;
    error?: any;
}

export type CustomerProjectAction =
    IRequestGetProjectAction |
    ICallbackGetProjectAction |
    IRequestGetEntryProjectsAction |
    ICallbackGetEntryProjectsAction |
    IRequestCreateEntryAction |
    ICallbackCreateEntryAction |
    IRequestDeleteEntryAction |
    ICallbackDeleteEntryAction
    ;

export interface ICustomerProjectActionCreator {
    requestGetProjectAction(
        item: GetProjectByCustomerRequest,
    ): IRequestGetProjectAction;

    callbackGetProjectAction(
        isSuccess: boolean,
        item?: GetProjectByCustomerResponse,
        error?: any,
    ): ICallbackGetProjectAction;

    requestGetEntryProjectsAction(): IRequestGetEntryProjectsAction;

    callbackGetEntryProjectsAction(
        isSuccess: boolean,
        item?: GetEntryProjectsByCustomerResponse,
        error?: any,
    ): ICallbackGetEntryProjectsAction;

    requestCreateEntryAction(
        item: CreateEntryByCustomerRequest,
    ): IRequestCreateEntryAction;

    callbackCreateEntryAction(
        isSuccess: boolean,
        error?: any,
    ): ICallbackCreateEntryAction;

    requestDeleteEntryAction(
        item: DeleteEntryByCustomerRequest,
    ): IRequestDeleteEntryAction;

    callbackDeleteEntryAction(
        isSuccess: boolean,
        error?: any,
    ): ICallbackDeleteEntryAction;

}

class ActionCreator implements ICustomerProjectActionCreator {
    public requestGetProjectAction = (
        item: GetProjectByCustomerRequest
    ): IRequestGetProjectAction => {
        return {
            type: CustomerProjectActionType.REQUEST_GET_PROJECT,
            item,
        };
    };

    public callbackGetProjectAction = (
        isSuccess: boolean,
        item?: GetProjectByCustomerResponse,
        error?: any,
    ): ICallbackGetProjectAction => {
        return {
            type: CustomerProjectActionType.CALLBACK_GET_PROJECT,
            isSuccess,
            item,
            error,
        };
    };

    public requestGetEntryProjectsAction = (): IRequestGetEntryProjectsAction => {
        return {
            type: CustomerProjectActionType.REQUEST_GET_ENTRY_PROJECTS,

        };
    };

    public callbackGetEntryProjectsAction = (
        isSuccess: boolean,
        item?: GetEntryProjectsByCustomerResponse,
        error?: any,
    ): ICallbackGetEntryProjectsAction => {
        return {
            type: CustomerProjectActionType.CALLBACK_GET_ENTRY_PROJECTS,
            isSuccess,
            item,
            error,
        };
    };

    public requestCreateEntryAction = (
        item: CreateEntryByCustomerRequest,
    ): IRequestCreateEntryAction => {
        return {
            type: CustomerProjectActionType.REQUEST_CREATE_ENTRY,
            item,
        };
    };

    public callbackCreateEntryAction = (
        isSuccess: boolean,
        error?: any,
    ): ICallbackCreateEntryAction => {
        return {
            type: CustomerProjectActionType.CALLBACK_CREATE_ENTRY,
            isSuccess,
            error,
        };
    };

    public requestDeleteEntryAction = (
       item: DeleteEntryByCustomerRequest,
    ): IRequestDeleteEntryAction => {
        return {
            type: CustomerProjectActionType.REQUEST_DELETE_ENTRY,
            item,
        };
    };

    public callbackDeleteEntryAction = (
        isSuccess: boolean,
        error?: any,
    ): ICallbackDeleteEntryAction => {
        return {
            type: CustomerProjectActionType.CALLBACK_DELETE_ENTRY,
            isSuccess,
            error,
        };
    };

}

export const createCustomerProjectActionCreator = (): ICustomerProjectActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_project_action.ts